import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class Route extends Element {
  setDefaultShapes () {
    this.shapes = [
      new Ren.Line({
        name: 'line',
        points: this.points,
        stroke: 'black',
        opacity: 0.1,
        strokeWidth: 8,
        lineCap: 'round'
      })
    ]
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)
    // [
    //   { code: 'ROUTE_FREE', shvMapping: ['enumFromBitRange', [0, 7, 0]], color: 'blue' },
    //   { code: 'ROUTE_RESQ', shvMapping: ['enumFromBitRange', [0, 7, 22]], color: 'blue' },
    //   { code: 'ROUTE_RES0', shvMapping: ['enumFromBitRange', [0, 7, 23]], color: 'blue' },
    //   { code: 'ROUTE_RES1', shvMapping: ['enumFromBitRange', [0, 7, 24]], color: 'blue' },
    //   { code: 'ROUTE_RES2', shvMapping: ['enumFromBitRange', [0, 7, 25]], color: 'blue' },
    //   { code: 'ROUTE_OCCPD', shvMapping: ['enumFromBitRange', [0, 7, 30]], color: 'blue' },
    //   { code: 'ROUTE_OCCPD_RES1N', shvMapping: ['enumFromBitRange', [0, 7, 31]], color: 'blue' },
    //   { code: 'ROUTE_OCCPD_RES2N', shvMapping: ['enumFromBitRange', [0, 7, 32]], color: 'blue' },
    //   { code: 'PERM_RESQ', shvMapping: ['enumFromBitRange', [0, 7, 42]], color: 'blue' },
    //   { code: 'PERM_RES0', shvMapping: ['enumFromBitRange', [0, 7, 43]], color: 'blue' },
    //   { code: 'PERM_RES1', shvMapping: ['enumFromBitRange', [0, 7, 44]], color: 'blue' },
    //   { code: 'PERM_RES2', shvMapping: ['enumFromBitRange', [0, 7, 45]], color: 'blue' },
    //   { code: 'PERM_OCCPD', shvMapping: ['enumFromBitRange', [0, 7, 50]], color: 'blue' }
    // ]

    if ([5, 6, 7].includes(status.routeStatus)) {
      this.modifyShape('line', 'opacity', 0.8)
      this.modifyShape('line', 'stroke', 'yellow')
      this.modifyShape('line', 'strokeWidth', 12)
    } else if (status.routeStatus === 3) {
      this.modifyShape('line', 'opacity', 0.8)
      this.modifyShape('line', 'stroke', 'green')
      this.modifyShape('line', 'strokeWidth', 12)
    } else if (status.routeStatus === 2) {
      this.modifyShape('line', 'opacity', 0.8)
      this.modifyShape('line', 'stroke', 'purple')
      this.modifyShape('line', 'strokeWidth', 12)
    } else {
      this.modifyShape('line', 'opacity', 0.1)
      this.modifyShape('line', 'stroke', 'black')
      this.modifyShape('line', 'strokeWidth', 8)
    }
  }
}
